import { useEffect, useState } from "react";
import { fetchPublishedBooks } from "../lib/booksApi";
import BookLandingView from "./BookLandingView";
import BooksCatalog from "./BooksCatalog";

// /books: with exactly one published book, shows its landing page directly
// (the original single-book behavior). With more than one, shows a
// catalog grid instead so every published book stays reachable — not just
// whichever was created most recently.
export default function BooksHomePage() {
  const [state, setState] = useState({ status: "loading", books: [] });

  useEffect(() => {
    fetchPublishedBooks().then(({ data }) => {
      const books = data ?? [];
      setState({
        status: books.length === 0 ? "empty" : books.length === 1 ? "single" : "catalog",
        books,
      });
    });
  }, []);

  useEffect(() => {
    if (state.status === "single") {
      document.title = state.books[0].title;
    } else if (state.status === "catalog") {
      document.title = "Free Ebooks";
    }
  }, [state.status, state.books]);

  if (state.status === "loading") return null;

  if (state.status === "empty") {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-sky-50 via-cyan-50 to-white px-6 text-center">
        <span className="text-5xl">📖</span>
        <h1 className="font-heading mt-4 text-3xl font-extrabold text-zinc-900 sm:text-4xl">
          Coming Soon
        </h1>
        <p className="mt-3 max-w-md text-zinc-600">
          We're putting the finishing touches on our free ebook — check back
          shortly!
        </p>
      </div>
    );
  }

  if (state.status === "catalog") {
    return <BooksCatalog books={state.books} />;
  }

  return <BookLandingView book={state.books[0]} />;
}
